import React from "react";
import { Form } from "../components/display/form";
import { Master } from "../components/layout/master";

export function Contact(props) {
  return (
    <Master {...props}>
    </Master>
  );
}